module.exports = __webpack_public_path__ + "img/e_2_7_r.286329b1.png";